import { render, staticRenderFns } from "./show-comment.vue?vue&type=template&id=f705e8ca&"
import script from "./show-comment.vue?vue&type=script&lang=js&"
export * from "./show-comment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports